(function () {
  function normalize(s) {
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function addBusinessDays(startDate, businessDays) {
    const d = new Date(startDate.getTime());
    let added = 0;
    while (added < businessDays) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatLt(date) {
    const parts = new Intl.DateTimeFormat('lt-LT', {
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    }).formatToParts(date);

    const month = parts.find(p => p.type === 'month')?.value || '';
    const day = parts.find(p => p.type === 'day')?.value || '';
    const weekday = parts.find(p => p.type === 'weekday')?.value || '';

    const acc = {
      'pirmadienis': 'pirmadienį',
      'antradienis': 'antradienį',
      'trečiadienis': 'trečiadienį',
      'ketvirtadienis': 'ketvirtadienį',
      'penktadienis': 'penktadienį',
      'šeštadienis': 'šeštadienį',
      'sekmadienis': 'sekmadienį'
    };

    return `${month} ${day} d., ${acc[weekday] || weekday}.`;
  }

  function isFast12(raw) {
    return raw.includes('1-2') || raw.includes('1–2') || raw.includes('1—2');
  }

  function show(el) { if (el) el.style.display = 'inline-flex'; }
  function hide(el) { if (el) el.style.display = 'none'; }

  function setEta(badge, days) {
    const etaEl = badge.querySelector('.pdp-badge__eta');
    if (!etaEl) return;
    etaEl.textContent = formatLt(addBusinessDays(new Date(), days));
  }

  function setRange(badge, text) {
    const rangeEl = badge.querySelector('.pdp-badge__range');
    if (!rangeEl) return;
    rangeEl.textContent = text;
  }

  function initBadges() {
    const storeBadge = document.querySelector('.pdp-badge--store');
    const whBadge = document.querySelector('.pdp-badge--warehouse');
    const supBadge = document.querySelector('.pdp-badge--supplier');

    if (!storeBadge && !whBadge && !supBadge) return;

    hide(storeBadge); hide(whBadge); hide(supBadge);

    const storeMeta = normalize(storeBadge?.querySelector('.js-store-meta')?.textContent);
    const whMeta = normalize(whBadge?.querySelector('.js-warehouse-meta')?.textContent);

    // Supplier meta: svarbu imti ORIGINAL (ne-normalizuotą) rodymui
    const supplierMetaEl = supBadge?.querySelector('.js-supplier-meta');
    const supplierMetaNorm = normalize(supplierMetaEl?.textContent);
    const supplierMetaOrig = (supplierMetaEl?.textContent || '').trim();

    const storeOK = storeMeta && storeMeta !== '0' && isFast12(storeMeta);
    const whFastOK = whMeta && whMeta !== '0' && isFast12(whMeta);
    const supplierOK = supplierMetaNorm && supplierMetaNorm !== '0';

    // PRIORITETAS: store (1–2) -> warehouse fast (1–2) -> supplier (3–7 ir pan.)
    if (storeOK && storeBadge) {
      show(storeBadge);
      setEta(storeBadge, 2);
      return;
    }

    if (whFastOK && whBadge) {
      show(whBadge);
      setEta(whBadge, 2);
      return;
    }

    if (supplierOK && supBadge) {
      show(supBadge);
      setRange(supBadge, supplierMetaOrig);
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', initBadges);
  document.addEventListener('shopify:section:load', initBadges);
})();